import { jwtDecode } from "jwt-decode";
import { logout, refreshAccessToken } from "../routines/user-operations";

let refreshTimer: ReturnType<typeof setTimeout> | null = null;
let lastActivityTime = Date.now();

export const initSessionTimers = () => {
  clearSessionTimers();

  // Track user activity
  document.addEventListener("mousemove", updateLastActivity);
  document.addEventListener("keydown", updateLastActivity);

  // Start proactive refresh scheduler
  scheduleProactiveTokenRefresh();
};

export const clearSessionTimers = () => {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }

  document.removeEventListener("mousemove", updateLastActivity);
  document.removeEventListener("keydown", updateLastActivity);
};

const updateLastActivity = () => {
  lastActivityTime = Date.now();
};

const scheduleProactiveTokenRefresh = () => {
  const expiryTime = parseInt(localStorage.getItem("expiryTime") || "0", 10);

  // Handle invalid expiryTime
  if (!expiryTime || expiryTime <= Date.now()) {
    console.warn("Invalid or expired expiryTime. Skipping proactive refresh.");
    return;
  }

  const refreshBeforeMs = 60 * 1000; // 1 minute before expiry
  const now = Date.now();
  const timeout = expiryTime - now - refreshBeforeMs;

  // If already expired or about to expire, skip
  if (timeout <= 0) {
    console.warn("Token already expired or too close to expiry.");
    return;
  }

  refreshTimer = setTimeout(async () => {
    const userIsActive = Date.now() - lastActivityTime < 1 * 60 * 1000; // 1 minute
    if(!userIsActive) {
      logout();
    }

    if (userIsActive) {
      try {
        console.info("Refreshing access token...proactive refresh");
        const newAccessToken = await refreshAccessToken();

        const decoded: any = jwtDecode(newAccessToken);
        if (decoded?.exp) {
          const newExpiry = decoded.exp * 1000;
          localStorage.setItem("expiryTime", newExpiry.toString());

          // Reschedule with new expiry
          scheduleProactiveTokenRefresh();
        }
      } catch (err) {
        console.error("Auto refresh failed:", err);
        logout();
      }
    } else {
      console.info("User inactive — skipping token refresh.");
    }
  }, timeout);
};